import { useNavigate } from "react-router-dom";
import "./Our_Packages.css";
import { getpackages } from "../../../utils/apis/packages/Homeapi";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { decodeId, encodeId, formatAmount } from "../../../utils/common";

const Our_Packages = () => {
  const navigate = useNavigate();
  const handleCardClick = (tour) => {
    navigate(`/tour-details/${encodeId(tour.id)}`);
  };
  const tours = [
    {
      id: 1,
      image: "/assets/images/tour-packages/img-1.png",
      days: "5 Days",
      title: "Express Leh-Ladakh",
      locations: ["Nubra", "Pangong", "Hemis"],
      price: "₹ 36,850",
    },
    {
      id: 2,
      image: "/assets/images/tour-packages/img-2.png",
      days: "7 Days",
      title: "Leh-Ladakh Monasteries",
      locations: ["Alchi", "Lamayuru", "Nubra", "Hemis"],
      price: "₹ 35,470",
    },
    {
      id: 3,
      image: "/assets/images/tour-packages/img-3.png",
      days: "7 Days",
      title: "Leh-Ladakh Monasteries",
      locations: ["Alchi", "Lamayuru", "Nubra", "Hemis"],
      price: "₹ 35,470",
    },
    {
      id: 4,
      image: "/assets/images/tour-packages/img-4.png",
      days: "5 Days",
      title: "Express Leh-Ladakh",
      locations: ["Nubra", "Pangong", "Hemis"],
      price: "₹ 36,850",
    },
    {
      id: 5,
      image: "/assets/images/tour-packages/img-1.png",
      days: "5 Days",
      title: "Express Leh-Ladakh",
      locations: ["Nubra", "Pangong", "Hemis"],
      price: "₹ 36,850",
    },
    {
      id: 6,
      image: "/assets/images/tour-packages/img-2.png",
      days: "5 Days",
      title: "Express Leh-Ladakh",
      locations: ["Nubra", "Pangong", "Hemis"],
      price: "₹ 36,850",
    },
    {
      id: 7,
      image: "/assets/images/tour-packages/img-3.png",
      days: "5 Days",
      title: "Express Leh-Ladakh",
      locations: ["Nubra", "Pangong", "Hemis"],
      price: "₹ 36,850",
    },
    {
      id: 8,
      image: "/assets/images/tour-packages/img-1.png",
      days: "5 Days",
      title: "Express Leh-Ladakh",
      locations: ["Nubra", "Pangong", "Hemis"],
      price: "₹ 36,850",
    },
    {
      id: 9,
      image: "/assets/images/tour-packages/img-4.png",
      days: "5 Days",
      title: "Express Leh-Ladakh",
      locations: ["Nubra", "Pangong", "Hemis"],
      price: "₹ 36,850",
    },
    {
      id: 10,
      image: "/assets/images/tour-packages/img-2.png",
      days: "5 Days",
      title: "Express Leh-Ladakh",
      locations: ["Nubra", "Pangong", "Hemis"],
      price: "₹ 36,850",
    },
    {
      id: 11,
      image: "/assets/images/tour-packages/img-3.png",
      days: "5 Days",
      title: "Express Leh-Ladakh",
      locations: ["Nubra", "Pangong", "Hemis"],
      price: "₹ 36,850",
    },
  ];

  const {
    IMG_URL,
  } = useContext(Context);

  const [packages, setPackages] = useState();
  const getAllPackages = async () => {
    const res = await getpackages({});

    if (res?.success) {
      setPackages(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }

  useEffect(() => {
    getAllPackages();
  }, []);

  return (
    <section className="Our_Packages">
      <div className="container">
        <div className="Our_Packages_header text-center">
          <h4 className="package_title">
            Our packages combine many sights into one trip.
          </h4>
          <p className="package_subtitle">
            You can fix the plan to match your interests and how much you want
            to spend. See our list of trips for more inspiration.
          </p>
        </div>

        <div className="tour_section">
          <div className="row">
            {packages?.map((tour) => (
              <div
                key={tour.id}
                className="col-lg-4 col-md-6 col-sm-6 col-12 mb-4"
              >
                <div
                  className="tour_card"
                  onClick={() => handleCardClick(tour)}
                >
                  {/* Image */}
                  <div className="tour_img_wrapper">
                    <img
                      src={IMG_URL + tour.image}
                      alt={tour.name || ""}
                      className="tour_img"
                    />
                    <div className="tour_badge">{tour.days > 1 ? `${tour.days} Days` : `${tour.days} Day`} </div>
                  </div>

                  {/* Content */}
                  <div className="tour_content">
                    <h5 className="tour_title">{tour.name || ""}</h5>

                    <div className="tour_locations">
                      {tour?.location || ""}
                      {/* {tour?.locations?.map((loc, index) => (
                        <span key={index}>
                          {loc}
                          {index !== tour.locations.length - 1 && (
                            <span className="dot">•</span>
                          )}
                        </span>
                      ))} */}
                    </div>

                    {/* Bottom */}
                    <div className="tour_bottom">
                      <div className="tour_price">
                        {formatAmount(tour?.per_car_price) || "0"}
                        <span>/car</span>
                      </div>

                      <button className="details_btn">DETAILS</button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Our_Packages;
